
import firebase from "firebase/compat/app";



const firebaseConfig = {
  apiKey: "AIzaSyCtTVl14E3s1kE9SAaJ41QV9TeEUXlsLq0",
  authDomain: "coproseapp-217dc.firebaseapp.com",
  projectId: "coproseapp-217dc",
  storageBucket: "coproseapp-217dc.appspot.com",
  messagingSenderId: "676520876526",
  appId: "1:676520876526:web:713f698d4f2497669216ff",
  measurementId: "G-9ZFMH2WDTP"
};


export const firebaseApp = firebase.initializeApp(firebaseConfig)